<template>
  <main role="main" class="col content-spacing">
    <loading-list v-if="viewData.loading"></loading-list>
    <b-container v-else>
      <b-row>
        <b-col>
          <div
            class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
          >
            <h1 class="h2">
              {{ viewData.id ? `Editar ${state.name}` : 'Novo Usuário' }}
            </h1>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-breadcrumb
            :items="[
              {
                text: 'Lista de ' + this.getProfileName(this.state.profile),
                href: '/#/' + this.state.profile + 's',
              },
              {
                text: 'Cadastro de usuários',
                href: '#',
                active: true,
              },
            ]"
          ></b-breadcrumb>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <b-form>
              <error-container v-bind:errors="viewData.errors || []" />

              <b-form-group
                id="input-group-1"
                label="Indicado por"
                label-for="input-1"
                v-if="
                  state.profile === 'consumer' || state.profile === 'investor'
                "
              >
                <v-select
                  @search="getParent"
                  :options="viewData.parents"
                  v-model="state.parentId"
                  label="label"
                />

                <b-form-invalid-feedback>{{
                  getError('socialNumber')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                id="input-group-1"
                label="CPF/CNPJ"
                label-for="input-1"
              >
                <b-form-input
                  v-model="state.socialNumber"
                  required
                  placeholder="Informe o CPF/CNPJ"
                  :state="isOk('socialNumber')"
                  v-mask="['###.###.###-##', '##.###.###/####-##']"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('socialNumber')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                id="input-group-1"
                label="Email"
                label-for="input-1"
              >
                <b-form-input
                  v-model="state.email"
                  type="email"
                  required
                  placeholder="Informe o email"
                  :state="isOk('email')"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('email')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group id="input-group-2" label="Nome" label-for="input-2">
                <b-form-input
                  v-model="state.name"
                  required
                  placeholder="Informe o nome"
                  :state="isOk('name')"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('name')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                id="input-group-1"
                label="Telefone"
                label-for="input-1"
              >
                <b-form-input
                  v-model="state.phone"
                  required
                  placeholder="Informe o Telefone"
                  v-mask="['(##) ####-####', '(##) #####-####']"
                  :state="isOk('phone')"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('phone')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                id="input-group-1"
                label="Data de Nascimento"
                label-for="input-1"
              >
                <b-form-datepicker
                  :state="isOk('birthDate')"
                  id="example-datepicker"
                  placeholder="Selecione uma data"
                  v-model="state.birthDate"
                  class="mb-2"
                ></b-form-datepicker>
                <b-form-invalid-feedback>{{
                  getError('birthDate')
                }}</b-form-invalid-feedback>

                <b-form-invalid-feedback>{{
                  getError('birthDate')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <image-upload
                :currentUrl="this.state.photoUrl"
                :updateUrl="updateUrl"
                :setLoading="setLoadingPhoto"
              ></image-upload>

              <submit-button
                v-if="!viewData.loadingPhoto"
                v-bind:action="() => save()"
                v-bind:label="'Salvar'"
              ></submit-button>
            </b-form>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </main>
</template>

<script>
import helpers from '../../vue/helpers';
import { Api } from '../../vue/api';
import * as _ from 'lodash';

const API = new Api();

export default {
  name: 'users-edit',
  data: function() {
    return {
      state: {
        email: '',
        name: '',
        socialNumber: '',
        profile: '',
        phone: '',
        photoUrl: '',
      },
      viewData: {
        id: 0,
        loading: false,
        loadingPhoto: false,
        errors: [],
        parents: [],
      },
    };
  },
  computed: {},
  beforeMount: async function() {
    const _id = this.$route.params ? this.$route.params.id : 0;
    if (_id) {
      this.viewData.id = _id;

      try {
        this.viewData.loading = true;
        const _profile = this.$route.params
          ? this.$route.params.accountProfile
          : '';

        const result = await API.post('/execute', {
          path: '/user/' + _id + `?profile=${_profile}`,
          method: 'get',
        });

        this.state = { ...result.model };

        if (result.model.parentAccount) {
          this.state.parentId = result.model.parentAccount;
        }

        this.state.profile = _profile;

        this.viewData.loading = false;
      } catch (ex) {
        this.$toast.error(helpers.getFirstError(ex));
      }
    } else {
      this.state.profile = this.$route.params.profile;
    }
  },
  methods: {
    getProfileName(profile) {
      if (profile && profile === 'consumer') {
        return 'Consumidores';
      } else if (profile && profile === 'trader') {
        return 'Comercializadores';
      } else if (profile && profile === 'partner') {
        return 'Parceiros';
      } else if (profile && profile === 'investor') {
        return 'Investidores';
      } else {
        return 'Usuários';
      }
    },
    isNumber($event) {
      return helpers.isNumber($event);
    },
    async getParent(search) {
      if (!search) {
        this.viewData.parents = [];
        return;
      }

      try {
        const result = await API.post('/execute', {
          path: '/partners-or-traders?search=' + search,
          method: 'get',
        });
        this.viewData.parents = result.model || [];
      } catch (ex) {
        this.viewData.parents = [];
      }
    },
    getError(property) {
      return helpers.getError(this.viewData.errors, property);
    },
    isOk(property) {
      const hasError = helpers.hasError(this.viewData.errors, property);

      if (hasError) {
        return false;
      }
    },
    updateUrl(url) {
      this.state.photoUrl = url;
    },
    setLoadingPhoto(loading) {
      this.viewData.loadingPhoto = loading;
    },
    async save() {
      let data = _.cloneDeep(this.state);
      data.socialNumber = _.replace(data.socialNumber, '.', '');
      data.socialNumber = data.socialNumber
        .replace(/\./g, '')
        .replace(/\-/g, '')
        .replace(/\//g, '');

      data.parentId = this.state.parentId ? this.state.parentId.id : null;

      try {
        const result = await API.post('/execute', {
          path: this.viewData.id ? `/user/${this.viewData.id}` : '/user/',
          method: this.viewData.id ? 'put' : 'post',
          data: data,
        });
        this.$router.push('/' + this.state.profile + 's');
        this.$toast.success('Usuário incluído com sucesso');
      } catch (ex) {
        this.viewData.errors = helpers.getErrors(ex);
      }
    },
  },
  components: {
    'image-upload': require('../image-upload.vue').default,
  },
};
</script>
